animateHandler = {
    uniqId = function() {
        return Math.round(new Date().getTime() + (Math.random() * 100));
    },
    
    animateScroll = function($obj, multipler = 1, reload = false){
        gsap.registerPlugin(ScrollTrigger);
                
        //handle if object has a multiple tags, so i put on loop
        $obj.each(function(){
            var $itm = $(this);
            var dataID = $itm.data('id');

            if (dataID == undefined) { 
                dataID = uniqId();
                
                $itm.attr('data-id', dataID);
                $itm.data('id', dataID);
            }

            var $tempText = $itm.html();
            var $contentTemp = $itm.parent().find('.content-temp[data-id='+dataID+']');
            if ((reload == false)) {
                $itm.after("<div class='content-temp hide' data-id="+dataID+">"+$tempText+"</div>");
            } else {
                $itm.html($contentTemp.html());
            }
        })

        var delay = 0.15 * multipler;
        var startAnchor = "top bottom";
        if (multipler > 1) {
            startAnchor = "top top";
        }

        if (($obj.length > 0) || ($($obj).length > 0)) {
            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: $obj,
                    // start: startAnchor,
                    // end: "bottom center", 
                    toggleActions: "play none none none",
                    //markers: true,
                },
            });

            var mySplitText = new SplitText($obj);
            mySplitText.split({type:"lines"});

            $obj.children().each(function(){
                var $currentChild = $(this);
                var val = $currentChild.html();

                $currentChild.addClass('item-animate-container');
                $currentChild.html("");
                $currentChild.append("<div class='item-animate'>"+val+"</div>");
                $currentChild.css({
                    'height': $currentChild.children().outerHeight()
                })
                // special handling for feature content: adjust width as to push arrows to the right
                // and make sure all items are same-width
                if (Foundation.MediaQuery.atLeast('medium') && val.indexOf('feature-content') != -1) {
                    var featureContainerWidth = $currentChild.closest('.cell').innerWidth();
                    $currentChild.find('.feature-content').css('width', featureContainerWidth+'px');
                }
            })

            var $itemAnimate = $obj.find('.item-animate');
            if ($itemAnimate) {
                tl.staggerFrom($itemAnimate , 0.75, {
                    y: 130,
                    ease: Power4.easeOut
                }, 0.065).delay(delay)
            }
        }
    },

    animateFadeIn = function($obj, $late = false){
        var startAnchor = "top bottom";
        var delay = 0.4;
        if ($late) {
            startAnchor = "5% top";
            delay = 1;
        }
        gsap.registerPlugin(ScrollTrigger);
        if (($obj.length > 0) || ($($obj).length > 0)) {
            
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: $obj,
                    start: startAnchor,
                    toggleActions: "restart none none none",
                    //markers: true,
                }
            });
    
            tl.from($obj,{
                autoAlpha: 0,  
                duration: 1,     
                y: 80,
            });

            tl.to($obj, {    
                autoAlpha: 1,
                duration: 1,     
                ease: Power0,    
                y: 0,    
            }); 

            tl.delay(delay);
        }
    },

    animateParallax = function($obj, $extra=false, $late = false){
        // var yFrom = ($extra) ? 300 : 200; 
        // var yTo = ($extra) ? -100 : 0;
        var yFrom = ($extra) ? 250 : 150; 
        var yTo = ($extra) ? -50 : 0; 

        var startAnchor = "top 80%";
        var endAnchor = "center 20%";
        if ($late) {
            startAnchor = "center top";
            endAnchor = "+=100% top";
        }
        
        gsap.registerPlugin(ScrollTrigger);
        if (($obj.length > 0) || ($($obj).length > 0)) {
            
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: $obj,
                    start: 'top bottom',
                    end: 'bottom top',
                    // start: startAnchor,
                    // end: endAnchor,
                    //toggleActions: "restart none none none",
                    scrub: true,
                    //markers: true
                }
            });

            tl.from($obj,{
                duration: 2,     
                y: yFrom,
            });

            tl.to($obj, {    
                duration: 2,     
                y: yTo,
            });

            tl.pause();
        }
    },

    animateFlipText: function(container, $text){
        var words = $text.split(","),
            //tl = gsap.timeline({repeat:-1, repeatDelay:0}),
            wordCount = words.length,
            word, element, i;

            //return '';
        var startTimes = 0;
        var incTimes = 2;
        var reDelay = incTimes * (wordCount-1);
        for(i = 0; i < wordCount; i++){
            word = words[i];

            var tl = gsap.timeline({repeat:-1, delay:startTimes,  repeatDelay:reDelay});

            element = $("<h1 class='fliping-text'>" + word + "</h1>").appendTo(container);

            tl.set(element, {
                autoAlpha: 0,
                rotationX: 180
            });

            tl.to(element, 0.5, {
                autoAlpha: 1,
                rotationX: 360,
            });

            tl.to(element, 0.5, {
                delay: 1.5,
                autoAlpha: 0,
                rotationX: 180,
            });

            tl.from(element, 0, {
                autoAlpha: 1,
                rotationX: 360,
            });

            startTimes += incTimes;
        }

        var newHeight = 0;
        container.find('.fliping-text').each(function() {
            var textHeight = $(this).height();
            if (textHeight > newHeight) {
                newHeight = textHeight;
            }
        });

        container.height(newHeight);
    },

    animateBackground = function(){
        var windowHeight = $(window).height();
        gsap.registerPlugin(ScrollTrigger);
        gsap.utils.toArray('.section').forEach((section, i) => {
            if (section.getAttribute('data-color')) {
                
                var colorAttr = section.getAttribute('data-color');      
                var sectionHeight = $(section).outerHeight();
                var topOffset = 0;
                if (Foundation.MediaQuery.only("small")) {
                    topOffset = 0;
                } else {
                    if (sectionHeight < windowHeight) {
                        topOffset = windowHeight;
                    } else {
                        topOffset = ((windowHeight) / sectionHeight * windowHeight) - $('header').outerHeight();
                    }    
                }
                topOffset = ~~topOffset;
                gsap.to(".fullpage-container", {
                    backgroundColor: colorAttr === "cream" ? "#fef9ee" : (colorAttr === "white" ? "#fefefe" : "#0a0a0a"),
                    immediateRender: false,
                    duration: 1,
                    scrollTrigger: {
                        trigger: section,
                        scrub: true,
                        start: "top+="+topOffset+" center",
                        end: "top+="+topOffset+" top",
                        // start: ($(section).offset().top) - $(section).outerHeight(),//"0% bottom",
                        // end: '+=500',
                        // start:'20% 75%',
                        // end: '60% bottom',
                        //start:'40% top',
                        //end: '+=250% ',
                        //markers: true,
                    }
                });
            }
        }); 
    }
}